// extracted by mini-css-extract-plugin
export default {"app":"Main_app__jdXs1","mainBody":"Main_mainBody__q6QPe","bottom":"Main_bottom__m9jmS","safeArea":"Main_safeArea__fBH7a","myPage":"Main_myPage__yeff9"};